var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99962 4.99962C6.79018 3.20906 9.26641 2.09998 12 2.09998C14.7335 2.09998 17.2098 3.20906 19.0003 4.99962C20.7909 6.79018 21.9 9.26641 21.9 12C21.9 14.7335 20.7909 17.2098 19.0003 19.0003C17.2098 20.7909 14.7335 21.9 12 21.9C9.26641 21.9 6.79018 20.7909 4.99962 19.0003C3.20906 17.2098 2.09998 14.7335 2.09998 12C2.09998 9.26641 3.20906 6.79018 4.99962 4.99962ZM12 3.89998C9.76297 3.89998 7.73921 4.80561 6.27241 6.27241C4.80561 7.73921 3.89998 9.76297 3.89998 12C3.89998 14.237 4.80561 16.2607 6.27241 17.7275C7.73921 19.1943 9.76297 20.1 12 20.1C14.237 20.1 16.2607 19.1943 17.7275 17.7275C19.1943 16.2607 20.1 14.237 20.1 12C20.1 9.76297 19.1943 7.73921 17.7275 6.27241C16.2607 4.80561 14.237 3.89998 12 3.89998Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82805 7.82805C8.89475 6.76134 10.371 6.09998 12 6.09998C13.629 6.09998 15.1052 6.76134 16.1719 7.82805C17.2386 8.89475 17.9 10.371 17.9 12C17.9 13.629 17.2386 15.1052 16.1719 16.1719C15.1052 17.2386 13.629 17.9 12 17.9C10.371 17.9 8.89475 17.2386 7.82805 16.1719C6.76134 15.1052 6.09998 13.629 6.09998 12C6.09998 10.371 6.76134 8.89475 7.82805 7.82805ZM12 7.89998C10.8675 7.89998 9.84378 8.3579 9.10084 9.10084C8.3579 9.84378 7.89998 10.8675 7.89998 12C7.89998 13.1324 8.3579 14.1562 9.10084 14.8991C9.84378 15.6421 10.8675 16.1 12 16.1C13.1324 16.1 14.1562 15.6421 14.8991 14.8991C15.6421 14.1562 16.1 13.1324 16.1 12C16.1 10.8675 15.6421 9.84378 14.8991 9.10084C14.1562 8.3579 13.1324 7.89998 12 7.89998Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3435 10.6565C13.0006 10.3136 12.5244 10.1 12 10.1C11.4756 10.1 10.9993 10.3136 10.6565 10.6565C10.3136 10.9993 10.1 11.4756 10.1 12C10.1 12.5244 10.3136 13.0006 10.6565 13.3435C10.9993 13.6863 11.4756 13.9 12 13.9C12.5244 13.9 13.0006 13.6863 13.3435 13.3435C13.6863 13.0006 13.9 12.5244 13.9 12C13.9 11.4756 13.6863 10.9993 13.3435 10.6565Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveOutline);
export default __webpack_public_path__ + "static/media/live_outline.26a3e4ae779a8890e481cc04adff734b.svg";
export { ForwardRef as ReactComponent };